import {
  BackNextSkip,
  clearValidation,
  isValidAge,
  ruleRunner,
  run,
  TextInput,
} from '@assetmark/common-elements';
import React, { useEffect, useState } from 'react';
import { TGoal } from '../../models/goal';
import styles from './retirement-age.module.css';

export interface TRetirementAgeProps {
  age: number;
  goal: TGoal;
  onBackButtonClick?: () => void;
  onSkipGoal?: () => void;
  saveRetirementAge?: (retirementAge: number) => void;
}

const RetirementAge: React.FC<TRetirementAgeProps> = (props) => {
  const [goal, setGoal] = useState<TGoal>(props.goal);
  const [birthYear, setBirthYear] = useState<number>(0);
  const [retirementAge, setrRetirementAge] = useState<string>(
    String(props.goal.retirementAge || ''),
  );
  const [buttonClass, setButtonClass] = useState<string>('disabled');
  const [isComplete, setIsComplete] = useState<boolean>(false);
  const [showErrors, setShowErrors] = useState<boolean>(false);
  const [validationErrors, setValidationErrors] = useState({
    retirementAge: '',
  });

  useEffect(() => {
    if (props.goal && props.goal.retirementAge) {
      setrRetirementAge(
        String(props.goal.retirementAge || ''),
      );
    }
    validateProfile('retirementAge', true);
  }, [props.goal]);

  useEffect(() => {
    if (props.goal && props.goal.BirthYear) {
      setBirthYear(props.goal.BirthYear);
    } else if (props.age) {
      setBirthYear(new Date().getFullYear() - Number(props.age));
    }
  }, [props.goal, props.age]);

  useEffect(() => {
    setButtonClass(isComplete ? '' : 'disabled');
  }, [isComplete]);

  const handleBackButtonClick = (event: any): void => {
    props.onBackButtonClick && props.onBackButtonClick();
  };
  const handleSaveGoal = (event: any): void => {
    props.saveRetirementAge && props.saveRetirementAge(Number(retirementAge));
  };
  const handleSkipGoal = (event: any): void => {
    props.onSkipGoal && props.onSkipGoal();
  };

  const validateProfile = (field: string, onChange: boolean): void => {
    const currentGoalState = { ...goal };
    const currentYear = new Date().getFullYear() - birthYear + 1;
    const errors = onChange
      ? run(currentGoalState, [ruleRunner(field, '', [clearValidation])])
      : run(currentGoalState, [
          ruleRunner('retirementAge', 'Age', [isValidAge(currentYear, 120)]),
        ]);

    const updatedValidationErrors = { ...validationErrors, ...errors };

    setShowErrors(true);
    setValidationErrors(updatedValidationErrors);
    setIsComplete(
      isRetirementAgeComplete(currentGoalState, updatedValidationErrors),
    );
  };
  const updateGoalState = (event: any): void => {
    const field = event.target.name;
    const updatedGoal = { ...goal };
    const targetYear = Number(event.target.value) + birthYear;
    updatedGoal[field] = event.target.value;
    updatedGoal.TargetYear = targetYear;
    updatedGoal.BirthYear = birthYear;
    setrRetirementAge(event.target.value);
    setGoal(updatedGoal);
    // setIsGoalProfileDirty(true);
    validateProfile(field, true);
  };
  const isRetirementAgeComplete = (
    goal: any,
    validationErrors?: any,
  ): boolean => {
    let returnItem = false;
    let errorOnPage = false;

    if (
      validationErrors &&
      (validationErrors.retirementAge &&
        validationErrors.retirementAge.length > 0)
    ) {
      errorOnPage = true;
    }
    if (errorOnPage === false) {
      returnItem = true;
    }
    return returnItem;
  };
  return (
    <div className={styles.retirementage_component}>
      <div className="col-sm-12">
        <h1 className={styles.title}>Retirement Age</h1>
        <div className="row">
          <div className={`col-sm-12 ${styles.label_text}`}>
            I’d like to retire when I’m
            <TextInput
              className={`${styles.retirementage_text} ${
                validationErrors.retirementAge &&
                validationErrors.retirementAge.length
                  ? styles.errorClass
                  : ''
              }`}
              value={retirementAge}
              name="retirementAge"
              onChange={updateGoalState}
              onBlur={() => validateProfile('retirementAge', false)}
              showError={showErrors}
              errorText={validationErrors.retirementAge || ''}
              type="underline"
              maxLength={3}
            />
            years old
          </div>
        </div>
        <div className={`${styles.mt_row_btn} ${styles.skipTextColor}`}>
          <BackNextSkip
            backButtonClassName={`button button-secondary button-lg ${styles.buttonLineHeight}`}
            backButtonText="BACK"
            onBackButtonClickHandler={handleBackButtonClick}
            nextButtonClassName={
              `button button-primary button-lg ml-2 mr-2 ${styles.buttonLineHeight} ` +
              buttonClass
            }
            nextButtonText="NEXT"
            onNextButtonClickHandler={handleSaveGoal}
            skipText="Skip This Step"
            onSkipClickHandler={handleSkipGoal}
            isDisabledNextButton={
              retirementAge &&
              retirementAge !== '' &&
              validationErrors.retirementAge.length === 0
                ? false
                : true
            }
          />
        </div>
      </div>
    </div>
  );
};

export default RetirementAge;
